import { LANGUAGES } from "../../common/constants";
import { ThemeAction, ThemeActions } from "./action";

export interface IThemeState {
  mode: "light" | "dark";
  language: LANGUAGES;
}

export const initialThemeState: IThemeState = {
  mode: "light",
  language: LANGUAGES.EN,
};

export const ThemeReducer = (state: IThemeState, action: ThemeAction) => {
  switch (action.type) {
    case ThemeActions.SET_THEME:
      return {
        ...state,
        mode: action.mode,
      };
    case ThemeActions.SET_LANGUAGE:
      return {
        ...state,
        language: action.language,
      };
    default:
      return {
        ...state,
      };
  }
};
